export default "__VITE_ASSET__BxjI1FWf__"